import {observer} from 'mobx-react';
import React from 'react';
import autobind from 'common/decorators/autobind.js';
import CollapsibleNumber from 'core/components/CollapsibleNumber.js';
import {
    HOSPITAL_CONTACT_TYPE,
    DIRECTORY_SEARCH_RESULT_CARD_LINK,
    HOSPITAL_CARD,
    AVATAR_SIZE_DEFAULT,
    AVATAR_SIZE_LARGE,
} from 'core/constants';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';
import Link from 'core/components/Link.js';

import {classNameHandler, browserCheckForIE11} from 'core/utils.js';
import {Card, Chip, Pill} from '@HealthShareAU/hs-component-library';

export default
@observer
class HospitalCard extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    constructor(props) {
        super(props);
        this.state = {
            modalDisplayed: false,
        };
        this.modalProps = {
            closeModal: this.closeModal,
            contactId: props.id,
            contactName: props.name,
            phoneNumber: props.phone,
            type: HOSPITAL_CONTACT_TYPE,
            locality: props.locality,
            items: [
                {
                    ...props,
                    type: HOSPITAL_CONTACT_TYPE,
                },
            ],
        };
    }

    @autobind
    closeModal() {
        this.setState({modalDisplayed: false});
    }

    @autobind
    handlePhoneClick() {
        this.setState({modalDisplayed: true});
    }

    renderPhoneNumber() {
        const {phone} = this.props;
        if (phone) {
            return (
                <Chip
                    customClass="chip-phone"
                    icon="phone"
                    key="chip-phone"
                    linkComponent={
                        <CollapsibleNumber
                            customClass="expanded"
                            number={phone}
                            onClick={this.handlePhoneClick}
                            title={`Click to show phone number for ${phone}`}
                        />
                    }
                />
            );
        }
    }

    renderAddress() {
        const {locality, street1} = this.props;
        const address = `${street1}, ${locality?.name}, ${locality?.state?.name}, ${locality?.post_code}`;
        return (
            <Chip
                customClass="chip-address"
                icon="address"
                key="chip-address"
                text={address}
            />
        );
    }

    renderHFRPill() {
        const {health_fund_relationship} = this.props;

        if (health_fund_relationship) {
            const {display_name, name, tooltip} = health_fund_relationship;
            const className = classNameHandler(name);
            return (
                <Pill
                    customClass={className}
                    key="HFRPill"
                    text={display_name}
                    tooltip={browserCheckForIE11() ? null : tooltip}
                />
            );
        }
    }

    render() {
        const {avatar, name, group, url} = this.props;
        const {modalDisplayed} = this.state;
        const {
            rootStore: {
                paramStore: {isClient},
            },
        } = this.context;

        const directoryCardProps = {
            avatarSizeTablet: isClient
                ? AVATAR_SIZE_DEFAULT
                : AVATAR_SIZE_LARGE,
            avatarSource: avatar && avatar,
            avatarIconType: 'hospital',
            chips: [this.renderAddress(), this.renderPhoneNumber()],
            dataTestId: 'hospitalCard',
            isIntegrated: isClient,
            subHeading: group ? group.name : null,
            heading: name,
            pills: [this.renderHFRPill()],
            size: 'default',
        };

        return (
            <li className="cell">
                {modalDisplayed && this.context.renderModal(this.modalProps)}
                <Link
                    customClass="card-link"
                    gaObjectType={HOSPITAL_CARD}
                    gaSelector={DIRECTORY_SEARCH_RESULT_CARD_LINK}
                    href={url}
                >
                    <span>{`${name} hospital link`}</span>
                </Link>
                <Card {...directoryCardProps} />
            </li>
        );
    }
}
